import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
import Home from '@/views/Home';

const NotFound = () => import('@/views/error/NotFound')
// const E404 = () => import('@/views/error/E404')
const Login = () => import('@/views/login/Login')
const DashBoard = () => import('@/views/dashboard/index')
const appList = () => import('@/views/appMarket/ApplyShelf')
const appUpload = () => import('@/views/appMarket/ApplyUpload')
const appCheck = () => import('@/views/appMarket/AppCheck')
const appInside= () => import('@/views/appMarket/AppInside')
// const AppManage = () => import('@/views/appMarket/AppManage')
const appAdd = () => import('@/views/appMarket/ApplyAdd')
const AppDeployConfig = () => import('@/views/appMarket/appDeployComponents/AppDeploy')
//厂商型号
const ManufacturerDvcType = () => import('@/views/manufacturer/manufacturerDvcType')
//应用参数配置
const AppParamConfig = () => import('@/views/appMarket/AppParamConfig')
const AddAppParamConfig = () => import('@/views/appMarket/AddAppParamConfig')
const EditAppParamConfig = () => import('@/views/appMarket/EditAppParamConfig')
const ViewAppParamConfig = () => import('@/views/appMarket/ViewAppParamConfig')


//设备管理
const OrgDevice = () => import('@/views/device/OrgDevice')
const organizationManagement = () => import('@/views/organizationManagement/organizationManagement')
const orgRepository = () => import('@/views/organizationManagement/orgRepository')
const operationLog = () => import('@/views/baseSetting/operationLog')
const operateDate = () => import('@/views/account/OperateDate')

const platformSettings = () => import('@/views/baseSetting/platformSettings')
//OS管理
const os = () => import('@/views/os/OSManagement')

const deviceTask = () => import('@/views/deviceTask/deviceTask')

const OccupyScreen = () => import('@/views/appMarket/OccupyScreen')
const deviceLifeCycle = () => import('@/views/deviceLifeCycle/deviceLifeCycle')
const AuthorityManagement = () => import('@/views/authority/AuthorityManagement')
const LogManage = () => import('@/views/logManage/logManage')
const BootAnimation = () => import(/* webpackChunkName: "BootAnimation" */ '@/views/sysCustomization/BootAnimation/bootAnimation')
const BootLogo = () => import(/* webpackChunkName: "BootLogo" */ '@/views/sysCustomization/BootLogo/bootLogo')
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: '/index',
    children: [  // 所有只有一级的导航放到这里，并指定level=1
      {
        path: '/index',
        name: 'yd.menu.dashboard',
        component: DashBoard,
        icon: 'icon-wujiaoxing',
        level: 1,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        level: 1,
        path: '/appList',
        component: appList,
        icon: 'icon-z-applist',
        name: 'yd.menu.applist',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/authorityManagement',
        component: AuthorityManagement,
        icon: 'icon-z-applist',
        name: 'yd.menu.authorityManagement',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        level: 1,
        path: '/appUpload',
        component: appUpload,
        icon: 'icon-z-applist',
        name: 'yd.menu.menu_app_upload',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        level: 1,
        path: '/appCheck',
        component: appCheck,
        icon: 'icon-z-applist',
        name: 'yd.menu.menu_app_check',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        level: 1,
        path: '/appInside',
        component: appInside,
        icon: 'icon-z-applist',
        name: 'yd.menu.menu_inside_app',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        name:"yd.menu.app_add",
        // name:"AppAdd",
        path: '/appUpload/appAdd',
        component: appAdd,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        },

      },
      {
        name:"yd.menu.app_param_config",
        path: '/appParamConfig/list',
        component: AppParamConfig,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        },

      },
      {
        name:"yd.menu.app_deploy",
        path: '/app/deploy',
        component: AppDeployConfig,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        },
      },
      {
        name:"yd.menu.occupy_screen",
        path: '/app/occupyScreen',
        component: OccupyScreen,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        },
      },
      //厂商类型
      {
        path: '/manufacturer',
        name: 'yd.menu.manufacturer_dvc_type',
        component: ManufacturerDvcType,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      //设备详情列表

      {
        path: '/device',
        name: 'yd.menu.device_detail',
        component: OrgDevice,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/device/tasks',
        name: 'yd.menu.device_task',
        component: deviceTask,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      //参数配置相关
      {
        path: '/appParamConfig/add',
        name: 'yd.menu.param_add',
        component: AddAppParamConfig,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/appParamConfig/edit',
        name: 'yd.menu.param_edit',
        component: EditAppParamConfig,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },{
        path: '/appParamConfig/editReal',
        name: 'yd.menu.param_edit1',
        component: EditAppParamConfig,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/appParamConfig/view',
        name: 'yd.menu.param_view',
        component: ViewAppParamConfig,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/notFound',
        name: 'yd.menu.notfound',
        component: NotFound
      },
      {
        path: '/organizationManagement',
        name: 'yd.menu.organization_management_another',
        component: organizationManagement,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/orgRepository',
        name: 'yd.menu.organization_management_repository',
        component: orgRepository,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/operationLog',
        name: 'yd.menu.operation_log',
        component: operationLog,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/platformSettings',
        name: 'yd.menu.platform_settings',
        component: platformSettings,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/device/ota',
        name: 'yd.menu.ota',
        component: os,
        icon: 'icon-z-zuzhijiegou',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/device/lifeCycle',
        name: 'yd.menu.device_life_cycle',
        component: deviceLifeCycle,
        icon: 'icon-z-zuzhijiegou',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/device/logManage',
        name: 'yd.menu.log_manage',
        component: LogManage,
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/sysCustomization/bootAnimation',
        name: 'deviceConfig.bootAnimation.tab_name',
        component: BootAnimation,
        icon: 'icon-z-yuandian',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
      {
        path: '/sysCustomization/bootLogo',
        name: 'deviceConfig.bootLogo.tab_name',
        component: BootLogo,
        icon: 'icon-z-yuandian',
        meta: {
          requiresAuth: true, // 是否需要登录
          nocache: true
        }
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/operateDate',
    name: 'operateDate',
    component: operateDate
  },
  {
    path: '*',
    redirect: '/notFound'
  },


]

export default routes;



// WEBPACK FOOTER //
// ./src/router/routes.js